export default __webpack_public_path__ + "static/media/538.c089ddf1.jpg";